import { Outlet } from 'react-router-dom';
import { isBeforeByUnix } from './utils/common';
import { ENVS } from './constants';
import dayjs from 'dayjs';
import { NotOpenPanel } from './components/AirdropPanel';

function App() {
  const isBeforeClaim = isBeforeByUnix(dayjs(ENVS.startTime).unix());

  if (ENVS.ENV === 'dev') {
    return <Outlet />;
  }

  if (isBeforeClaim) {
    return <NotOpenPanel />;
  }

  return <Outlet />;
}

export default App;
